module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "main main--full-height"
  }, [(_vm.orgLoading === 'loading' || _vm.orgLoading === 'initial') ? _c('ui-module-loader', {
    key: "loader",
    attrs: {
      "messages": [
        'Please give us a moment'
      ]
    }
  }) : _vm._e(), _vm._v(" "), (_vm.orgLoading === 'done') ? _c('div', {
    key: _vm.orgLoading,
    staticClass: "group"
  }, [_c('div', {
    staticClass: "grid grid--auth"
  }, [_c('div', {
    staticClass: "grid__item grid__item--2"
  }, [_c('ui-auth', {
    attrs: {
      "id": "login"
    }
  }), _vm._v(" "), (_vm.hideVerifiyForm) ? _c('p', {
    staticClass: "mt fsi"
  }, [_vm._v("\n          Don't have an account? "), _c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Explore")]), _vm._v(" these resources to see what's right for you. \n        ")], 1) : _vm._e(), _vm._v(" "), (!_vm.hideVerifiyForm) ? _c('ui-auth', {
    staticClass: "pat2",
    attrs: {
      "id": "verify",
      "success": _vm.success,
      "send-verification": _vm.resendVerification,
      "verify-text": _vm.resendEmailCodeText
    }
  }) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "button",
      "mode": "out-in"
    }
  }, [(_vm.resendVerificationResponse) ? _c('p', {
    staticClass: "p pat mt0"
  }, [_vm._v("\n            " + _vm._s(_vm.resendVerificationResponse) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resendErrorMessage),
      expression: "resendErrorMessage"
    }],
    staticClass: "c-error mt mb"
  }, [_vm._v("\n          " + _vm._s(_vm.resendErrorMessage) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "grid__item grid__item--2"
  }, [_c('img', {
    attrs: {
      "src": _vm.image,
      "width": "100%",
      "alt": ""
    }
  })])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-096f4a16"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/auth/Login.vue
// module id = 477
// module chunks = 0